import * as yup from 'yup'; // for everything

export const schema = yup.object().shape({
  code: yup.string().required(),
});
